import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc3145b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_app_form_item = _resolveComponent("app-form-item")!

  return (_openBlock(), _createBlock(_component_app_form_item, {
    "control-class": _ctx.controlClass,
    "error-message": _ctx.errorMessage || _ctx.propError
  }, {
    "label-append": _withCtx(() => [
      _renderSlot(_ctx.$slots, "label-append", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codeLength, (n) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-code__item",
            key: n
          }, [
            _createVNode(_component_el_input, _mergeProps({
              ref: el => { _ctx.inputListRef[n - 1] = el },
              name: _ctx.name,
              modelValue: _ctx.valueList[n - 1],
              "onUpdate:modelValue": ($event: any) => ((_ctx.valueList[n - 1]) = $event)
            }, _ctx.$attrs, {
              type: "text",
              inputmode: "numeric",
              onFocus: ($event: any) => (_ctx.onFocus(n - 1)),
              onInput: ($event: any) => (_ctx.onInput($event, n - 1)),
              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.onBackspace(n - 1)), ["prevent"]), ["backspace"])
            }), _createSlots({ _: 2 }, [
              _renderList(_ctx.$slots, (_, name) => {
                return {
                  name: name,
                  fn: _withCtx((slotData) => [
                    _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)), undefined, true)
                  ])
                }
              })
            ]), 1040, ["name", "modelValue", "onUpdate:modelValue", "onFocus", "onInput", "onKeydown"])
          ]))
        }), 128))
      ])
    ]),
    _: 3
  }, 8, ["control-class", "error-message"]))
}